// React
import React from 'react'
import PropTypes from 'prop-types'

// Appt
import Box from '../../simple/box/Box.js'
import Text from '../../simple/text/Text.js'

// Font Awesome
import ActionButton from '../actionButton/ActionButton.js'
import Divider from '../../simple/divider/Divider.js'


/**
 * `ActionList` renders a Card to display a counter of items eg. number of posts
 */
class ActionList extends React.Component {

  render () {


    return (
      <Box
                background="white"
                direction="column"
                // wrap="wrap"
                gap="none"
                flex="grow"
                pad="medium"
                round="small"
                width="auto"
              >
                {this.props?.title && <>
                    <Text size='medium' weight='bold'>{this.props.title}</Text>
                    <Divider color='primary' margin={{ top: 'none', bottom: 'small' }} />
                </>}
                  {this.props?.data?.length > 0 ? this.props.data.map((item, index) => (
                      <Box direction="row" key={index} gap="none">
                        <Box style={{ width: '100%' }}>
                          <ActionButton
                            plain
                            margin={{ top: 'none', bottom: 'xsmall' }}
                            onClick={() => {
                            this.props.onClick(item)
                            }}
                            label={<Text weight="bold" size="large">{`${item.title}`}</Text>}
                        />
                        </Box>
                      </Box>
                    )) : 'No data to display'}
              </Box>
    
    )
  }
}


ActionList.propTypes = {
  /** 
   * The title for the card
   */
  title: PropTypes.string,
  /** 
   * The title for the card
   */
  description: PropTypes.string,
  /**
   * A large sized number displayed in the card
   */
  onClick: PropTypes.func,
  /**
   * The icon displayed on the card
   */
}


export default ActionList
